<template>
<div>
    <div class="allmiddle keyboardContainer">
        <el-input 
            :value="input"
            class="input"
            @input="onInputChange"
            placeholder="请输入管理员账号"
        >
        <el-button slot="append" type="danger" class="bt" @click="goNext">确 定</el-button> 
        </el-input>
        <SimpleKeyboard @onChange="onChange" @onKeyPress="onKeyPress" :input="input"/>        
    </div>
        <homeBtn @goHome="goHome" ref="homeBtn"></homeBtn>  
</div>
</template>

<script>
import SimpleKeyboard from "@/components/SimpleKeyboard";
import homeBtn from '@/components/homeButton'
export default {
    name: "inputName",
    components: {
        SimpleKeyboard,        
        homeBtn
    },
    data() {
        return {
            input: "",            
            manageUrl: this.myStore.state.manageUrl,
            countTimeSecond: 60,
            timeoutDialogVisible: false//打开超时提示框
        }
    },
    created () {
        
    },
    mounted () {

    },
    destroyed () {
        
    },
    methods: {
        onChange(input){
            this.input = input;
        },
        onKeyPress(button){
            console.log("button", button);
        },
        onInputChange(input){
            this.input = input.target.value;
        },
        goNext(){
            this.$router.push({ path: this.manageUrl+'/inputPassword' , query: {name:this.input}}); 
        },
        goHome() {
            this.$router.push({ path: this.myStore.state.mainUrl });                
        },
        async countDownEndHandler(time) {
            if(time === 0) {
                this.timeoutDialogVisible = true;
                this.$refs.operationTimeout.openDialog();
            } 
        },
        timeoutEndHandler() {
            this.timeoutDialogVisible = false;
            this.goHome();
        }
    }
}
</script>

<style scoped>
    @import "~@/assets/css/buttons/buttons.css";
    .simple-keyboard {
        max-width: 60rem;
    }
    .keyboardContainer /deep/ .el-input-group__append{
        background: #75e475;
        border: solid 1px #75e475;
    }
    .keyboardContainer /deep/ .el-input__inner  {
        width: 100%;
        height: 5rem;
        padding: 10px;
        font-size: 35px;
        border: solid 8px #75e475;
        box-sizing: border-box;
        text-align: center;
        letter-spacing: 5px;
        font-family: "Microsoft YaHei","微软雅黑",Arial,sans-serif;
    }
    .keyboardContainer {
        transition: margin-top 1s ease-in-out 0.5s, opacity 1s ease-in-out 0.5s, width 0.3s linear;
        overflow: hidden;
        width: 100%;
        z-index: 3;
        max-width: 850px;
        margin: 0 auto;
        font-size: 20px;
        margin-bottom: 40px;
    }
    .keyboardContainer /deep/.hg-theme-default .hg-button{
        height: 3.3rem;
    }
    .keyboardContainer /deep/.el-input-group__append button.el-button, .el-input-group__append div.el-select .el-input__inner, .el-input-group__append div.el-select:hover .el-input__inner, .el-input-group__prepend button.el-button, .el-input-group__prepend div.el-select .el-input__inner, .el-input-group__prepend div.el-select:hover .el-input__inner {
        font-size: 1.8rem;
        color: white;
    }
</style>